// Ported from platform-legacy/readonly/platform/components/DesignSystemBanners.js
// v3 → v3.14: extend → extends, props: wrapper stripped, childExtend → childExtends.
// TODO: verify TutorialBanner dependency — not in default-config and may need
// to be supplied by a sub-app's components/index.js if this is mounted.
export const DesignSystemBanners = {
  extends: 'Flex',
  align: 'stretch space-between',
  gap: 'B1',
  childrenAs: 'state',
  children: [
    {
      title: 'Setting up global themes',
      p: '15 sec tutorial',
      theme: 'theme',
      href: '/design-system/watch/colors'
    },
    {
      title: 'Adding more colors',
      p: '3 mins tutorial',
      theme: 'color',
      href: '/design-system/watch/colors'
    },
    {
      title: 'How typography works',
      p: '3 mins tutorial',
      theme: 'typography',
      href: '/design-system/watch/colors'
    },
    {
      title: 'How to get spacing units',
      p: '45 sec tutorial',
      theme: 'space',
      href: '/design-system/watch/colors'
    },
    {
      title: 'Adding and using icons',
      p: '45 sec tutorial',
      theme: 'icons',
      href: '/design-system/watch/colors'
    }
  ],
  childExtends: 'TutorialBanner'
}
